// src/components/MyHealthTabs.jsx
// Route-based tab bar shared by PatientHealthTimeline, PatientCarePlanPage,
// PatientCurrentMarkersPage, and PatientLifestylePage. The four pages are
// separate routes (/patient/timeline, /patient/care-plan, /patient/markers,
// /patient/lifestyle) but present as one "My Health" destination in the
// sidebar — this is what makes them read as tabs of the same section
// instead of unrelated pages. Mirrors WalletBillingTabs.jsx.
//
// "Markers" moved here from a card inside the Health Story page (which just
// linked out to /patient/markers) — it's a full page in its own right, not
// a summary, so it belongs as a tab alongside Health Story and Care Plan
// rather than a "View all" link buried inside one of them.
//
// "Lifestyle" sits after Markers for the same reason: the AI lifestyle plan
// (already shown to navigators inside the per-record triage report — see
// LifestyleTab in TriageReportModal.js) belongs next to the markers it was
// generated from, as its own destination rather than buried in a modal only
// staff can open.

import React from 'react';
import { NavLink } from 'react-router-dom';

export default function MyHealthTabs() {
  return (
    <div className="tabs-bar">
      <NavLink
        to="/patient/timeline"
        className={({ isActive }) => `tab-btn${isActive ? ' active' : ''}`}
      >
        Health Story
      </NavLink>
      <NavLink
        to="/patient/care-plan"
        className={({ isActive }) => `tab-btn${isActive ? ' active' : ''}`}
      >
        Care Plan
      </NavLink>
      <NavLink
        to="/patient/markers"
        className={({ isActive }) => `tab-btn${isActive ? ' active' : ''}`}
      >
        Markers
      </NavLink>
      <NavLink
        to="/patient/lifestyle"
        className={({ isActive }) => `tab-btn${isActive ? ' active' : ''}`}
      >
        Lifestyle
      </NavLink>
    </div>
  );
}
